import { render, staticRenderFns } from "./SiteFaq.vue?vue&type=template&id=6f50405a&scoped=true"
var script = {}
import style0 from "./SiteFaq.vue?vue&type=style&index=0&id=6f50405a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50405a",
  null
  
)

export default component.exports